import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import UnitStandardsTable from '../UnitStandardsTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import UnitStandardSetupSearch from '../program/UnitStandardSetupSearch';
import LinkDialog from "../LinkDialog";
import ViewUtils from "./../../ViewUtils";
import { ViewContainer } from "./../../View.jsx";
import Prompt from '../../widgets/Prompt';
import AlertItem from "../../widgets/AlertItem";


const utils = new ViewUtils();

const headCells = [
    { id: 'SAQAUnitStandardID', numeric: false, disablePadding: true, label: 'SAQA Unit Standard ID' },
    { id: 'SAQAUnitStandardTitle', numeric: false, disablePadding: true, label: 'SAQA Unit Standard Title' },
    { id: 'Credits', numeric: false, disablePadding: true, label: 'Credits' },
    { id: 'UnitStandardType', numeric: false, disablePadding: true, label: 'Unit Standard Type' }
];

const toolbarRef = React.createRef();

class LearnerQualificationUSSearch extends Component {

    constructor(props) {
        super(props);

        this.state = {
            linkDialogOpen: false,
            selectedLinkType: null,
            selectedLinkStandards: null,
            selectedUnitStandard: null,
            keyUpSwitch: false,
            propmtOpen: false,
            promptTitle: "Unlink Unit Standard From The Learners Qualification",
            promptContent: "Are you sure you want to unlink this unit standard from the Learners qualification?",
            message: "",
            messageStyle: "",
            searchParameters: [
                { Name: "LearnerQualificationID", Value: this.props.location.state.QualificationID },
                { Name: "LearnerID", Value: this.props.location.state.LearnerID }
            ]
           
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        {
                            contextMenu: [
                                { id: 1, description: "Elective" }
                            ],
                            id: 'link', label: 'Link', tooltip: 'link the selected unit standard to the Learners qualification', width: "60px"
                        },
                        { id: 'link', label: '', contextIcon: 'LinkIcon', tooltip: 'Link unit standard/s to the Learners qualification'},
                        { id: 'unlink', label: '', icon: 'LinkOffIcon', tooltip: 'Un-link the selected unit standard from the Learners qualification', disabled: utils.isNull(this.state.selectedUnitStandard) }
                    ]
                }
            ]
        };
    }

    handleToolbarButtonClick(buttonId) {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/AddLearnerQualification',
                state: {
                    LearnerID: this.props.location.state.LearnerID,
                    QualificationID: this.props.location.state.QualificationID,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames
                }
            });
        } else if ("unlink" === buttonId) {
            this.setState({ promptOpen: true })
        }
    }

    successCallback = (response) => {
        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({
                selectedUnitStandard: null,
                selectedLinkType: null,
                selectedLinkStandards: null,
                selectedUnitStandard: null,
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase()
            })
            this.setState({ searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)) })
        }
        else if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase()
            })
        }
    }


    unlinkUnitstandard(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("unlink", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedUnitStandard}&LearnerQualificationID=${this.props.location.state.QualificationID}`
        utils.invokeUrlDelete(fullUrl, this.successCallback, null);
    }

    handleToolbarButtonMenuClick(menu) {
        this.setState({ linkDialogOpen: true, selectedLinkType: menu });
    }

    postLinkHandler(isCancel, linked) {
        if (linked === true) {
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                linkDialogOpen: false, selectedUnitStandard: null
            });
        }
        else if (isCancel === true) {
            this.setState({
                linkDialogOpen: false
            })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({
                selectedUnitStandard: selection[0].Id,
                message: "",
                messageStyle: ""
            });
        } else {
            this.setState({
                selectedUnitStandard: null,
                message: "",
                messageStyle: ""
            });
        }
        toolbarRef.current.setButtonDisabled("unlink", selection === null || selection.length === 0);
    }

    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    render() {
        return (
            <ViewContainer>
                <p className="breadcrumbs">
                    {"Learner Qualification Unit Standards"}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <div className="searchResults">
                    <EnhancedToolbar highlight={false}
                        ref={toolbarRef}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        buttonMenuClickHandler={(menu) => this.handleToolbarButtonMenuClick(menu)}
                        config={this.toolbarConfig} />
                    <UnitStandardsTable headCells={headCells} onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                        dataUrl="api/sims/LearnerQualification/GetLearnerQualificationUSSearch"
                        height={"50vh"}
                        searchParameters={this.state.searchParameters} paged={false} />
                </div>

                <LinkDialog open={this.state.linkDialogOpen} type={this.state.selectedLinkType}
                    title={this.props.location.state.QualificationTitle}
                    closeHandler={(isCancelled, linked) => this.postLinkHandler(isCancelled, linked)}
                    dialogTitle={`Link Unit Standards to the Qualification for Learner: ${this.props.location.state.learnerNames}`}
                    linkName={"UnitStandards"} postUrl={"api/sims/LearnerQualification/linkQualificationUnitStandards"} usePost={true}
                    programmeId={this.props.location.state.QualificationID}
                >
                    <UnitStandardSetupSearch dataUrl="api/sims/LearnerQualification/GetSearchLinkableQualificationUnitStandards"
                        multiSelect={true} showTitle={false}
                        programmeId={this.props.location.state.QualificationID}
                        mode="lookup"
                    />
                </LinkDialog>

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => this.unlinkUnitstandard(`api/sims/LearnerQualification/unlinkLearnerqualificationUnitstandard`)}
                    closePrompt={this.closePrompt}
                />
            </ViewContainer>

        );
    }
}

export default withRouter(
    connect()(LearnerQualificationUSSearch)
);
